import { Box, Text, Flex, For, Link } from "@chakra-ui/react";
import ShadowBox from "@/components/partials/ShadowBox";
import revalidate from '@/lib/revalidate';

export default async function Categories() {
  const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/portal/componentes/categorias`, {
    next: revalidate('REVALIDATE_LATERAL_CATEGORIES')
  });

  const result = await res.json();
  const { data: categories } = result;

  return (
    <ShadowBox text="Categorias"  padding="6">
      <Flex flexDirection="column">
          <For each={categories} index="index">
              {category => (
                <Link
                  key={category._id}
                  href={`/categoria/${category.taxSlug}`}
                  title={category.taxName}
                  py="1"
                  _hover={{ color: 'blue.500', pl: '1' }}
                  >
                    {category.taxName}
                  </Link>
              )}
          </For>
      </Flex>
    </ShadowBox>
  )
}
